import { defineNuxtPlugin } from "@nuxtjs/composition-api";
import Vue from "vue";
// import { createLoginDialog } from "~/components/LoginDialog";

import addLoginDialog from '~/components/LoginDialog/api.js'
import LoginDialog from '~/components/LoginDialog/index.vue'
// Vue.prototype.$createLoginDialog = createLoginDialog;
export default defineNuxtPlugin(() => {
    addLoginDialog(Vue, LoginDialog)
})